import type { UseCase } from '@/core/shared'
import type { UserRepository } from '@/core/user'

export const unsubscribeUserFromPayPerMonth: UseCase<UserRepository, 'unsubscribeUserFromPayPerMonth'> = repository => {
  return async (unsubscribeContract) => {
    await repository.unsubscribeUserFromPayPerMonth(unsubscribeContract)
  }
}
